module.exports = __webpack_public_path__ + "img/aramex.9096e7b2.png";